import { Menu, Theme } from "@ugc-ui/lego";
import styled from "@emotion/styled";

export const ProfileMenuStyled = styled(Menu)<{ theme: Theme }>`
  & > div {
    top: 40px;
    left: -300px;
    width: 310px;
  }
`;
